import { Sizes } from "components/forms/NumberSelector"
import { StepPage, StepPageConfig } from "features/subscription-process/navigation/Steps/StepPage"
import { FC, ReactNode } from "react"
import { StepConfig } from "features/subscription-process/navigation/Steps/createStepConfig"


interface StepPageWrapperProps {
  stepConfig: StepConfig | null
  onNext: () => void
  onPrevious: () => void
  children: ReactNode
  containerSize?: Sizes | 'full' | undefined
  withoutPadding?: boolean
}

export const StepPageWrapper: FC<StepPageWrapperProps> = ({
  stepConfig,
  onNext,
  onPrevious,
  children,
  containerSize = Sizes["5xl"],
  withoutPadding = false
}) => {
  // Si pas de config ou pas de next, afficher seulement le composant
  if (!stepConfig?.next) {
    return <>{children}</>
  }

  const pageConfig: StepPageConfig = {
    nextConfig: {
      label: stepConfig.next.label ?? "Suivant",
      disabled: stepConfig.next.disabled,
      onClick: onNext,
    },
    ...(stepConfig.prev && {
      prevConfig: {
        label: stepConfig.prev.label ?? "Retour",
        disabled: stepConfig.prev.disabled,
        onClick: onPrevious,
      },
    }),
    containerSize,
    withoutPadding
  }

  return <StepPage {...pageConfig}>{children}</StepPage>
}
